import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services';
import { SnackbarService } from '../../services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'prism-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  showLoader$ = this.authService.showLoginLoader.asObservable();
  minPassChars = 6;
  loggedInSub: Subscription;

  loginForm: FormGroup = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(this.minPassChars)]]
  });

  constructor(private formBuilder: FormBuilder,
              private authService: AuthenticationService,
              private snackbarService: SnackbarService
  ) {
    // Subscribe to logged in state changes
        this.loggedInSub = this.authService.isLoggedIn$().subscribe(isLoggedIn => {
            if (isLoggedIn === false) {
                // User logged out, reset and enable the form
                this.loginForm.reset();
                this.loginForm.enable();
            }
        });
  }

  ngOnInit() {
  }

  public onLogin(validState: any) {
    if (validState) {
      const email = this.loginForm.controls['email'].value;
      const password = this.loginForm.controls['password'].value;

      if (this.loginForm.valid) {
        this.loginForm.disable();
        this.authService.login(email, password)
          .then(() => null)
          .catch(error => {
            this.loginForm.enable();
            this.snackbarService.handleError(error);
          });
      }
    }
  }
}
